import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import womenImage from '../../assets/women-2.webp';

import { styles } from './DiscountBanner.styles';

interface DiscountBannerProps {
  onClick: () => void;
}

export function DiscountBanner({ onClick }: DiscountBannerProps) {
  const slots = styles();

  const t = useTranslations('article.page.loyalty');

  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.imageBlock()}>
          <div className={slots.imageContainer()}>
            <Image
              src={womenImage}
              alt=""
              fill
              className={slots.image()}
            />
          </div>
        </div>
        <div className={slots.content()}>
          <h2 className={slots.title()}>{t('discount.title')}</h2>
          <div className={slots.discountBlock()}>
            <div>
              <div className={slots.discount()}>
                15<span className={slots.discountPercent()}>%</span>
              </div>
            </div>
            <div>
              <div
                className={slots.discountText({
                  highlight: true,
                  className: 'mb-2'
                })}
              >
                <span className="-mt-1 inline-block">
                  {t('discount.discount')}
                </span>
              </div>
              <div className={slots.discountText({ highlight: true })}>
                {t('discount.cashback')}
              </div>
              <div className={slots.discountText()}>{t('discount.buy')}</div>
            </div>
          </div>
          <div className={slots.description()}>{t('discount.description')}</div>
          <UiKitButtonBase
            className={slots.button()}
            color="primary"
            onClick={onClick}
          >
            {t('button')}
          </UiKitButtonBase>
        </div>
      </div>
    </div>
  );
}
